import { FunctionComponent } from "react";

import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";

import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

import { IconDefinition } from "@fortawesome/fontawesome-common-types";

import { User } from "@/pages/Public/pages/Login/schema/login";

import { Checkbox } from "@/components/Checkbox/Checkbox";
import { Icon } from "@/components";
import { EmailIcon } from "@/components/EmailIcon/EmailIcon";
import { BrandsIcon } from "@/components/BrandsIcon/BrandsIcon";

import { classNames } from "@/utils/classNames";

import { Sender } from "../../Sender";

export const SendersInfo: FunctionComponent<{
	senders: Sender[];
	sendingUsers?: User[];
	setSenders: (senders: Sender[]) => void;
	error?: boolean;
}> = ({ error, senders, sendingUsers, setSenders }) => {
	return (
		<div className="flex flex-col gap-2">
			<div className={classNames("flex flex-col gap-2 border-b border-gray-200 pb-4")}>
				<div className="flex flex-row gap-2 items-center">
					<div className="flex flex-col gap-2">
						<Checkbox
							error={error}
							isChecked={senders.some((s) => s.active)}
							onChange={() => {
								setSenders(
									senders.map((s) => {
										return {
											...s,
											active: senders.every((s) => s.active) ? false : true,
										};
									})
								);
							}}
						/>
					</div>
					<div className="text-sm text-text-meta">All connected sending users</div>
				</div>

				<div className="flex flex-col gap-2 ml-3">
					<div className={classNames("ml-4")}>
						<div className={classNames("flex flex-row gap-2 items-center")}>
							<div className="flex flex-col gap-2">
								<Checkbox
									error={error}
									isChecked={senders
										?.filter((s) => s.type === "email" && s.emailType === "primary")
										.every((s) => s.active)}
									isDisabled={senders
										?.filter((s) => s.type === "email" && s.emailType === "primary")
										.every((s) => s.deactivated)}
									onChange={() => {
										setSenders(
											senders.map((s) => {
												if (s.type === "email" && s.emailType === "primary") {
													return {
														...s,
														active: senders
															?.filter((s) => s.type === "email" && s.emailType === "primary")
															.every((s) => s.active)
															? false
															: true,
													};
												}

												return s;
											})
										);
									}}
								/>
							</div>

							<div className="text-text-meta text-sm font-medium gap-2 flex items-center">
								All Primary Emails
							</div>
						</div>
					</div>
				</div>

				<div className="flex flex-col gap-2 ml-3">
					<div className={classNames("ml-4")}>
						<div className={classNames("flex flex-row gap-2 items-center")}>
							<div className="flex flex-col gap-2">
								<Checkbox
									error={error}
									isChecked={senders
										?.filter((s) => s.type === "email" && s.emailType === "secondary")
										.every((s) => s.active)}
									isDisabled={senders
										?.filter((s) => s.type === "email" && s.emailType === "secondary")
										.every((s) => s.deactivated)}
									onChange={() => {
										setSenders(
											senders.map((s) => {
												if (s.type === "email" && s.emailType === "secondary") {
													return {
														...s,
														active: senders
															?.filter((s) => s.type === "email" && s.emailType === "secondary")
															.every((s) => s.active)
															? false
															: true,
													};
												}

												return s;
											})
										);
									}}
								/>
							</div>

							<div className="text-text-meta text-sm font-medium gap-2 flex items-center">
								All Secondary Emails
							</div>
						</div>
					</div>
				</div>
			</div>
			{sendingUsers?.map((sUser: User, index: number) => {
				const userSenders = senders.filter((s) => s.userId === sUser.id);
				const linkedinSenders = userSenders.filter((s) => s.type === "linkedin");
				const hasLinkedin = linkedinSenders.length > 0;

				if (userSenders.length === 0) {
					return null;
				}

				return (
					<div
						key={sUser.id}
						className={classNames(
							"flex flex-col gap-2 border-b border-gray-200 pb-4",
							index === sendingUsers.length - 1 && "border-b-0 pb-0"
						)}
					>
						<div className="flex flex-row gap-2 items-center  w-full justify-between">
							<div className="flex flex-row gap-2 items-center">
								{hasLinkedin && (
									<div className="">
										<Checkbox
											error={error}
											isChecked={linkedinSenders.every((s) => s.active)}
											isDisabled={userSenders.length > 0 && userSenders.every((s) => s.deactivated)}
											onChange={() => {
												setSenders(
													senders.map((s) => {
														if (s.userId === sUser.id) {
															return {
																...s,
																active: linkedinSenders.every((s) => s.active) ? false : true,
															};
														}

														return s;
													})
												);
											}}
										/>
									</div>
								)}
								<div className="text-sm text-text-meta">
									{sUser.firstName} {sUser.lastName}
								</div>
							</div>
							{hasLinkedin && (
								<span className="flex flex-row gap-2 items-center text-xs text-text-meta bg-brand-white px-2 py-1 rounded-md border border-border-light w-fit">
									<div
										className={`bg-blue-action rounded-full w-4 h-4 flex flex-row items-center justify-center cursor-pointer text-white text-xxs  font-bold`}
									>
										<BrandsIcon className="w-2.5 h-2.5" icon={faLinkedinIn as IconDefinition} />
									</div>
									LinkedIn Account
								</span>
							)}
						</div>
						{senders.filter(
							(s) => s.userId === sUser.id && s.type === "email" && s.emailType === "primary"
						).length > 0 && (
							<div className="flex flex-col gap-2 ml-3">
								{senders
									.filter(
										(s) => s.userId === sUser.id && s.type === "email" && s.emailType === "primary"
									)
									.map((sender, index) => (
										<div
											key={`${sUser.id}-${sender.emailId || "linkedin"}-${index}`}
											className={classNames(sender.type === "email" && "ml-4")}
										>
											<div
												className={classNames(
													"flex flex-row gap-2 items-center",
													sender?.deactivated && "opacity-50"
												)}
											>
												<div className="flex flex-col gap-2">
													<Checkbox
														error={error}
														isChecked={sender?.active}
														isDisabled={sender?.deactivated}
														onChange={() => {
															setSenders(
																senders.map((s) => {
																	if (
																		s.userId === sender.userId &&
																		s.type === sender.type &&
																		s.emailType === sender.emailType &&
																		s.emailAddress === sender.emailAddress
																	) {
																		return {
																			...s,
																			active: !s.active,
																		};
																	}

																	return s;
																})
															);
														}}
													/>
												</div>
												{sender?.type === "email" && (
													<div className="w-[20px]">
														<EmailIcon />
													</div>
												)}

												{sender?.type === "email" ? (
													<div className="text-text-meta text-sm font-medium gap-2 flex items-center w-full justify-between">
														{sender?.emailAddress}
														<span className="flex flex-row gap-2 items-center text-xs text-text-meta bg-brand-white px-2 py-1 rounded-md border border-border-light">
															<div
																className={`w-4 h-4 flex flex-row items-center justify-center cursor-pointer text-text-meta text-xxs  font-bold`}
															>
																<Icon className="w-4 h-4" icon={faEnvelope} />
															</div>
															Primary Email
														</span>
													</div>
												) : (
													<div className="text-text-meta text-sm font-medium w-[150px]">
														{
															sendingUsers?.find((user: User) => user.id === sender.userId)
																?.firstName
														}{" "}
														{
															sendingUsers?.find((user: User) => user.id === sender.userId)
																?.lastName
														}
													</div>
												)}
											</div>
										</div>
									))}
							</div>
						)}
						{senders.filter(
							(s) => s.userId === sUser.id && s.type === "email" && s.emailType === "secondary"
						).length > 0 && (
							<div className="flex flex-col gap-2 ml-4">
								<div key={`${sUser.id}-secondary-${index}`} className={classNames("ml-3")}>
									<div className={classNames("flex flex-row gap-2 items-center")}>
										<div className="flex flex-col gap-2">
											<Checkbox
												isChecked={senders
													.filter(
														(s) =>
															s.userId === sUser.id &&
															s.type === "email" &&
															s.emailType === "secondary"
													)
													?.every((s) => s.active)}
												isDisabled={senders
													.filter(
														(s) =>
															s.userId === sUser.id &&
															s.type === "email" &&
															s.emailType === "secondary"
													)
													?.every((s) => s.deactivated)}
												onChange={() => {
													setSenders(
														senders.map((s) => {
															if (
																s.userId === sUser.id &&
																s.type === "email" &&
																s.emailType === "secondary"
															) {
																return {
																	...s,
																	active: senders
																		.filter(
																			(s) =>
																				s.userId === sUser.id &&
																				s.type === "email" &&
																				s.emailType === "secondary"
																		)
																		?.every((s) => s.active)
																		? false
																		: true,
																};
															}

															return s;
														})
													);
												}}
											/>
										</div>
										<div className="w-[20px]">
											<EmailIcon />
										</div>

										<div className="text-text-meta text-sm font-medium gap-2 flex items-center">
											All Secondary Emails
										</div>
									</div>
								</div>
							</div>
						)}
						{senders.filter(
							(s) => s.userId === sUser.id && s.type === "email" && s.emailType === "secondary"
						).length > 0 && (
							<div className="flex flex-col gap-2 ml-10">
								{senders
									.filter(
										(s) =>
											s.userId === sUser.id && s.type === "email" && s.emailType === "secondary"
									)
									.map((sender, index) => (
										<div
											key={`${sUser.id}-${sender.emailId || "linkedin"}-${index}`}
											className={classNames(sender.type === "email" && "ml-4")}
										>
											<div
												className={classNames(
													"flex flex-row gap-2 items-center",
													sender?.deactivated && "opacity-50"
												)}
											>
												<div className="flex flex-col gap-2">
													<Checkbox
														error={error}
														isChecked={sender?.active}
														isDisabled={sender?.deactivated}
														onChange={() => {
															setSenders(
																senders.map((s) => {
																	if (
																		s.userId === sender.userId &&
																		s.type === sender.type &&
																		s.emailType === sender.emailType &&
																		s.emailAddress === sender.emailAddress
																	) {
																		return {
																			...s,
																			active: !s.active,
																		};
																	}

																	return s;
																})
															);
														}}
													/>
												</div>
												{sender?.type === "email" && (
													<div className="w-[20px]">
														<EmailIcon />
													</div>
												)}

												{sender?.type === "email" ? (
													<div className="text-text-meta text-sm font-medium gap-2 flex items-center w-full justify-between">
														{sender?.emailAddress}
														<span className="flex flex-row gap-2 items-center text-xs text-text-meta bg-brand-white px-2 py-1 rounded-md border border-border-light">
															<div
																className={`w-4 h-4 flex flex-row items-center justify-center cursor-pointer text-text-meta text-xxs  font-bold`}
															>
																<Icon className="w-4 h-4" icon={faEnvelope} />
															</div>
															Secondary Email
														</span>
													</div>
												) : (
													<div className="text-text-meta text-sm font-medium w-[150px]">
														{
															sendingUsers?.find((user: User) => user.id === sender.userId)
																?.firstName
														}{" "}
														{
															sendingUsers?.find((user: User) => user.id === sender.userId)
																?.lastName
														}
													</div>
												)}
											</div>
										</div>
									))}
							</div>
						)}
					</div>
				);
			})}
		</div>
	);
};
